<template>
  <hm-content title="商品列表">
    <div slot="header">
      <hm-step :steps="steps" :step="2"></hm-step>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="toAddCommodity"
          >新增商品</el-button
        >
      </div>
      <div>
        <el-select
          clearable
          v-model="storeOutletId"
          placeholder="选择门店"
          size="small"
          filterable
          class="mr10"
        >
          <!-- <el-option label="全部门店"
                     :value="0"></el-option> -->
          <el-option
            v-for="item in storeList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          clearable
          :disabled="!storeOutletId"
          v-model="categoryId"
          placeholder="选择商品分类"
          size="small"
          filterable
          class="mr10"
        >
          <!-- <el-option label="全部门店"
                     :value="0"></el-option> -->
          <el-option
            v-for="item in categoryList.list"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="productType"
          placeholder="商品类型"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="实物商品" :value="2"></el-option>
          <el-option label="服务商品" :value="1"></el-option>
        </el-select>
        <el-select
          clearable
          v-model="status"
          placeholder="商品状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="下架" :value="0"></el-option>
          <el-option label="上架" :value="1"></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="productName"
          placeholder="输入商品名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="search"
          clearable
          placeholder="输入名称"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="commondityList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
          label="序号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="productName"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="price"
          label="商品售价(元)"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberPrice"
          label="会员售价(元)"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所属门店"
          prop="storeOutlet"
        >
          <!-- <template slot-scope="scope">{{scope.row.storeOutletId === 0 ? '全部门店' : scope.row.storeOutlet}}</template> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="所属商品分类"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="productType"
          label="商品类型"
        >
          <template slot-scope="scope">{{
            scope.row.productType === 1 ? "服务商品" : "实物商品"
          }}</template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="商品状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status === 0 ? "下架" : "上架" }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row.id)"
              >编辑</el-button
            >
            <!-- <el-button type="text"
                       size="small"
                       @click="remove(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="commondityList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import HmStep from "@/components/HmStep";

export default {
  components: { HmStep },
  data() {
    return {
      steps: [
        {
          link: "ProductCategory",
          name: "商品分类列表"
        },
        {
          link: "CommodityList",
          name: "商品列表"
        },
        {
          link: "ProductList",
          name: "服务卡列表"
        }
      ],
      productType: "",
      categoryId: "",
      storeOutletId: "",
      status: "",
      pageSize: 10,
      currentPage: 1,
      productName: ""
    };
  },
  computed: mapGetters(["commondityList", "storeList", "categoryList"]),
  mounted() {
    this.queryList();
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
  },
  watch: {
    storeOutletId(storeOutletId) {
      if (storeOutletId) {
        this.$store.dispatch("queryCategoryList", {
          pageSize: 999,
          isShow: 1,
          storeOutletId
        });
      }
    }
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryCommodityList", {
        productName: this.productName,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeOutletId: this.storeOutletId,
        categoryId: this.categoryId,
        productType: this.productType,
        status: this.status
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toAddCommodity() {
      this.$router.push({ name: "AddCommodity" });
    },
    edit(id) {
      this.$router.push({
        name: "EditCommodity",
        query: {
          id: String(id)
        }
      });
    },
    remove(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteProduct", {
            id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "删除商品成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.tag {
  background-color: #fce6f0;
  padding: 2px 4px;
  margin-right: 5px;
  border-radius: 3px;
  color: #666;
  word-break: keep-all;
}
</style>
